import Marquee from "react-fast-marquee";

export const EditorialMarquee = ({ words, dark = false }) => (
  <div
    data-testid="marquee"
    className={`py-8 md:py-10 border-y ${dark ? "bg-[#2c2826] border-[#3a352f]" : "bg-[#EAE5DC] border-[#ddd4c7]"}`}
  >
    <Marquee speed={38} gradient={false} autoFill>
      {words.map((w, i) => (
        <span key={i} className="flex items-center">
          <span className={`font-serif italic text-3xl md:text-5xl px-8 md:px-12 ${dark ? "text-[#F7F5F0]" : "text-[#2c2826]"}`}>
            {w}
          </span>
          <span className="text-[#985F47] text-2xl md:text-4xl">&bull;</span>
        </span>
      ))}
    </Marquee>
  </div>
);
